import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue')
        },
        {
            path: '/plugin/',
            component: () => import('./layouts/Nav.vue'),
            children: [
                {
                    path: 'plugin',
                    component: () => import('./views/plugin/Plugin.vue')
                },
                {
                    path: 'plugin-info',
                    component: () => import('./views/plugin/Plugin-info.vue')
                }
            ]
        },
        {
            path: '/passport/',
            component: () => import('./layouts/Passport.vue'),
            children: [
                {
                    path: 'register',
                    component: () => import('./views/passport/Register.vue')
                },
                {
                    path: 'login',
                    component: () => import('./views/passport/Login.vue')
                },
                {
                    path: 'reset-password',
                    component: () => import('./views/passport/ResetPassword.vue')
                }
            ]
        },
        {
            path: '/dashboard/',
            component: () => import('./layouts/Dashboard.vue'),
            redirect: '/dashboard/user/index',
            children: [
                {
                    path: 'user/index',
                    component: () => import('./views/user/Index.vue')
                },
                {
                    path: 'host/index',
                    component: () => import('./views/host/Index.vue')
                },
                {
                    path: 'host/edit',
                    component: () => import('./views/host/Edit.vue')
                },
                {
                    path: 'app-order/index',
                    component: () => import('./views/app-order/Index.vue')
                },
                {
                    path: 'app-order/edit',
                    component: () => import('./views/app-order/Edit.vue')
                },
                {
                    path: 'plugin-order/index',
                    component: () => import('./views/plugin-order/Index.vue')
                },
                {
                    path: 'plugin-order/edit',
                    component: () => import('./views/plugin-order/Edit.vue')
                },
                {
                    path: 'mch/index',
                    component: () => import('./views/mch/Index.vue')
                },
                {
                    path: 'admin/',
                    component: () => import('./layouts/Admin.vue'),
                    children: [
                        {
                            path: 'app/index',
                            component: () => import('./views/admin/app/Index.vue')
                        },
                        {
                            path: 'app/edit',
                            component: () => import('./views/admin/app/Edit.vue')
                        },
                        {
                            path: 'app-order/index',
                            component: () => import('./views/admin/app-order/Index.vue')
                        },
                        {
                            path: 'app-order/edit',
                            component: () => import('./views/admin/app-order/Edit.vue')
                        },
                        {
                            path: 'app-renew/index',
                            component: () => import('./views/admin/app-renew/Index.vue')
                        },
                        {
                            path: 'app-renew/edit',
                            component: () => import('./views/admin/app-renew/Edit.vue')
                        },
                        {
                            path: 'platform-version/index',
                            component: () => import('./views/admin/platform/Index.vue')
                        },
                        {
                            path: 'platform-version/edit',
                            component: () => import('./views/admin/platform/Edit.vue')
                        },
                        {
                            path: 'app-version/index',
                            component: () => import('./views/admin/app-version/Index.vue')
                        },
                        {
                            path: 'app-version/edit',
                            component: () => import('./views/admin/app-version/Edit.vue')
                        },
                        {
                            path: 'user/index',
                            component: () => import('./views/admin/user/Index.vue')
                        },
                        {
                            path: 'user/edit',
                            component: () => import('./views/admin/user/Edit.vue')
                        },
                        {
                            path: 'agreement/index',
                            component: () => import('./views/admin/agreement/Index.vue')
                        },
                        {
                            path: 'agreement/edit',
                            component: () => import('./views/admin/agreement/Edit.vue')
                        },
                        {
                            path: 'host/index',
                            component: () => import('./views/admin/host/Index.vue')
                        },
                        {
                            path: 'host/edit',
                            component: () => import('./views/admin/host/Edit.vue')
                        },
                        {
                            path: 'renew/index',
                            component: () => import('./views/admin/renew/Index.vue')
                        },
                        {
                            path: 'renew/edit',
                            component: () => import('./views/admin/renew/Edit.vue')
                        },
                        {
                            path: 'host/auth-warning',
                            component: () => import('./views/admin/host/AuthWarning.vue')
                        },
                        {
                            path: 'plugin-order/index',
                            component: () => import('./views/admin/plugin-order/Index.vue')
                        },
                        {
                            path: 'plugin/index',
                            component: () => import('./views/admin/plugin/Index.vue')
                        },
                        {
                            path: 'plugin/edit',
                            component: () => import('./views/admin/plugin/Edit.vue')
                        },
                        {
                            path: 'plugin/version',
                            component: () => import('./views/admin/plugin/Version.vue')
                        },
                        {
                            path: 'plugin/version-edit',
                            component: () => import('./views/admin/plugin/VersionEdit.vue')
                        },
                        {
                            path: 'version/index',
                            component: () => import('./views/admin/version/Index.vue')
                        },
                        {
                            path: 'version/edit',
                            component: () => import('./views/admin/version/Edit.vue')
                        },
                        {
                            path: 'data/index',
                            component: () => import('./views/admin/data/Index.vue')
                        },
                        {
                            path: 'history/index',
                            component: () => import('./views/admin/history/Index.vue')
                        },
                        {
                            path: 'task/index',
                            component: () => import('./views/admin/task/Index.vue')
                        },
                        {
                            path: 'task/fail',
                            component: () => import('./views/admin/task/Fail.vue')
                        },
                        {
                            path: 'template/index',
                            component: () => import('./views/admin/template/Index.vue')
                        },
                        {
                            path: 'template/edit',
                            component: () => import('./views/admin/template/Edit.vue')
                        },
                        {
                            path: 'template-order/index',
                            component: () => import('./views/admin/template-order/Index.vue')
                        },
                        {
                            path: 'mch/index',
                            component: () => import('./views/admin/mch/Index.vue')
                        },
                        {
                            path: 'mch/edit',
                            component: () => import('./views/admin/mch/Edit.vue')
                        },
                        {
                            path: 'mch/level',
                            component: () => import('./views/admin/mch/Level.vue')
                        },
                        {
                            path: 'mch/level-edit',
                            component: () => import('./views/admin/mch/LevelEdit.vue')
                        },
                        {
                            path: 'news/index',
                            component: () => import('./views/admin/news/Index.vue')
                        },
                        {
                            path: 'news/edit',
                            component: () => import('./views/admin/news/Edit.vue')
                        },
                        {
                            path: 'plugin/cat-index',
                            component: () => import('./views/admin/plugin/CatIndex.vue')
                        },
                        {
                            path: 'plugin/cat-edit',
                            component: () => import('./views/admin/plugin/CatEdit.vue')
                        },
                        {
                            path: 'illegal/index',
                            component: () => import('./views/admin/illegal/Index.vue')
                        },
                        {
                            path: 'illegal/edit',
                            component: () => import('./views/admin/illegal/Edit.vue')
                        },
                        {
                            path: 'customer/index',
                            component: () => import('./views/admin/customer/Index.vue')
                        },
                        {
                            path: 'customer/edit',
                            component: () => import('./views/admin/customer/Edit.vue')
                        }
                    ]
                }
            ]
        }
    ]
})
